/**
 * This file is part of DNG
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 *
 * @author Nicolò Martini <nicmartnic@gmail.com>
 */
require(["common"], function($) {
    require(["jquery"], function($) {
        $(".btn-group .btn").on('click', function(){
            $( "#loading").show();
            $( "#timetable").remove();

            var url = $(this).find('[data-load-url]').data('load-url');

            $( "#timetable-wrapper").load(url + ' #timetable', function() {
                $( "#loading").hide();
            });
        });
    });
});
define("timetable", function(){});

